import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import { useParams } from 'react-router-dom';
import VesselDetails from '../../../components/vessels/general/details';
import VesselRequisitionDetails from '../../../components/vessels/requisitions/general/details';

interface VesselRequisitionDetailsPageProps {
}

const VesselRequisitionDetailsPage: React.FC<VesselRequisitionDetailsPageProps> = (props: VesselRequisitionDetailsPageProps) => {
    const {topbar} = useStore();
    const params: any = useParams();

    useEffect(() => {
        topbar.show("Vessels", [
            {key: "home", icon: faHome, href: "/"},
            {key: "vessels", text: 'Vessels'},
            {key: "requisitions", text: 'Requisitions'}
        ]);
    }, []);

    return <Stack>
        <VesselRequisitionDetails requisitionId={params.requisitionId} />
    </Stack>;
};

export default VesselRequisitionDetailsPage;
